import {
  LoginWithFacebookResponseDTO,
  LoginWithFacebookResponseDTOFailed,
  LoginWithFacebookResponseDTOSuccessLogin,
  LoginWithFacebookResponseDTOSuccessRegistration,
} from "../models";

export const isError = (
  response: LoginWithFacebookResponseDTO,
): response is LoginWithFacebookResponseDTOFailed => {
  return LoginWithFacebookResponseDTOFailed.safeParse(response).success;
};

export const isSuccessLogin = (
  response: LoginWithFacebookResponseDTO,
): response is LoginWithFacebookResponseDTOSuccessLogin => {
  return LoginWithFacebookResponseDTOSuccessLogin.safeParse(response).success;
};

export const isSuccessRegistration = (
  response: LoginWithFacebookResponseDTO,
): response is LoginWithFacebookResponseDTOSuccessRegistration => {
  return LoginWithFacebookResponseDTOSuccessRegistration.safeParse(response)
    .success;
};
